"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobxReact = require("mobx-react");
var _reactIntl = require("react-intl");
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
require("!style-loader!css-loader!./ErrorModalDialog.css");
var _class, _ErrorModalDialog;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Dialog = require("@react/react-spectrum/Dialog").default;

/**
 * Top-level layout of Progress View
 */
let ErrorModalDialog = exports.default = (0, _mobxReact.observer)(_class = (_ErrorModalDialog = class ErrorModalDialog extends _react.default.Component {
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const supportUrl = appStore.configStore.getConfig().supportUrl;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sdk-ErrorModalDialog-errorDialog"
    }, /*#__PURE__*/_react.default.createElement(Dialog, {
      className: "sdk-ErrorModalDialog-errorMsg",
      variant: "error",
      title: this.props.title || this.props.intl.formatMessage({
        id: "error"
      }),
      confirmLabel: this.props.intl.formatMessage({
        id: this.props.confirmLabel || "ok"
      }),
      onConfirm: () => this.props.onConfirm()
    }, this.props.message, supportUrl && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "error.contact.support",
      values: {
        jobId: appStore.configStore.getConfig().sessionId,
        a: msg => /*#__PURE__*/_react.default.createElement("a", {
          target: "_blank",
          href: supportUrl,
          rel: "noreferrer"
        }, msg),
        span: msg => /*#__PURE__*/_react.default.createElement("span", null, msg)
      }
    })));
  }
}, _ErrorModalDialog.propTypes = {
  message: _propTypes.default.string,
  title: _propTypes.default.string,
  confirmLabel: _propTypes.default.string,
  onConfirm: _propTypes.default.func.isRequired,
  intl: _propTypes.default.objectOf(_propTypes.default.any).isRequired
}, _ErrorModalDialog.defaultProps = {
  message: "",
  title: "",
  confirmLabel: "ok"
}, _ErrorModalDialog)) || _class;